import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import ja from 'date-fns/locale/ja';

import ScrollToTop from './ScrollToTop';
// import Header from './molecules/common/Header';
// import Footer from './molecules/common/Footer';
import Search from './pages/Search';
import PlanList from './pages/PlanList';
import PlanDetail from './pages/PlanDetail';
import EntryConfirmation from './pages/step/EntryConfirmation';
import Mail from '../components/pages/step/Mail';
import Login from '../components/pages/step/Login';
import Entry from '../components/pages/step/Entry';
import FinalConfirmation from './pages/step/FinalConfirmation';
import Completed from '../components/pages/step/Completed';
import Error, { DynamicError } from '../components/pages/Error';
import QueryParams from './QueryParams';
import ErrorModal from './atoms/modal/ErrorModal';
import { setErrorMessages, setOnCloseErrorModal } from '../modules/app';
import { BASENAME, LAYOUT_TYPES } from '../constants';
import Step from './molecules/common/Step';
import LocalStorageManager from './LocalStorageManager';
import Tooltip, { TooltipProvider } from './atoms/Tooltip';
import SessionContainer from './SessionContainer';
import Breadcrumb from './molecules/common/Breadcrumb';
import Head from './Head';

ja.options.weekStartsOn = 0;
registerLocale('ja', ja);
setDefaultLocale('ja');

const appSelector = (state) => state.app;

const App = () => {
  const { errorMessages, layoutType, currentStep, onCloseErrorModal } = useSelector(appSelector);
  const dispatch = useDispatch();

  const stepLayout = layoutType === LAYOUT_TYPES.step;

  return (
    <Router
      basename={BASENAME}
    >
      <Head />
      <TooltipProvider>
        <ScrollToTop />
        <LocalStorageManager />
        <Tooltip />
        <div className="isPC">
          <Breadcrumb />
        </div>
        <div className="htmlWrapper">
          {stepLayout && (
            <Step isCurrent={currentStep} />
          )}
          <div className={stepLayout ? 'stepContainer' : ''}>
            <Switch>
              <Route path={'/'} exact>
                <Error />
              </Route>
              <Route path={'/search'} exact>
                <QueryParams />
                <Search />
              </Route>
              <Route path={'/searcha'} exact>
                <QueryParams />
                <Search affiliate />
              </Route>
              <Route path={'/plan_detail'} exact>
                <QueryParams />
                <PlanDetail />
              </Route>
              <Route path={'/plan_list'} exact>
                <QueryParams />
                <PlanList />
              </Route>
              <Route path={'/entry_confirm'} exact>
                <QueryParams />
                <EntryConfirmation />
              </Route>
              <Route path={'/mail'} exact>
                <Mail />
              </Route>
              <Route path={'/login'} exact>
                <SessionContainer>
                  <Login />
                </SessionContainer>
              </Route>
              <Route path={'/entry_customer'} exact>
                <SessionContainer>
                  <Entry />
                </SessionContainer>
              </Route>
              <Route path={'/final_confirm'} exact>
                <SessionContainer>
                  <FinalConfirmation />
                </SessionContainer>
              </Route>
              <Route path={'/complete'} exact>
                <SessionContainer>
                  <Completed />
                </SessionContainer>
              </Route>
              <Route path={'/notfound'} exact>
                <Error />
              </Route>
              <Route path={'/timeout'} exact>
                <Error
                  title="セッションが切れました"
                  descHTML="セッションタイムアウトしました。<br />お手数おかけしますが、TOPページから再度お探しください。"
                />
              </Route>
              <Route path={'/error'} exact>
                <DynamicError />
              </Route>
              <Route>
                <Redirect to={'/notfound'} />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="isSP">
          <Breadcrumb />
        </div>
        <ErrorModal
          errorMessages={errorMessages}
          onClose={() => {
            dispatch(setErrorMessages([]));
            onCloseErrorModal && onCloseErrorModal();
            setOnCloseErrorModal(undefined);
          }}
        />
      </TooltipProvider>
    </Router>
  );
};

export default App;
